module.exports = __webpack_public_path__ + "media/images/icon-svg/visa-c658a8a921c299346611060f80276689.svg";